import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { login as authServiceLogin } from '../services/authService';
import { useAuth } from '../hooks/useAuth';

/**
 * @file LoginPage.tsx
 * @brief Anmeldeseite für die Anwendung.
 *
 * Diese Komponente bietet ein Formular zur Eingabe von Benutzername und Passwort.
 * Bei erfolgreicher Anmeldung werden das Authentifizierungstoken und die Benutzerrolle im
 * localStorage gespeichert und der Benutzer zur Kalenderseite weitergeleitet.
 *
 * @returns {JSX.Element} Ein React-Element, das die Anmeldeseite darstellt.
 */
const LoginPage = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();
  const { login } = useAuth();

  const handleLogin = async () => {
    try {
      const response = await authServiceLogin(username, password);
      if (response.accessToken) {
        login(response.accessToken, response.role, response.username, response.permissions);
        navigate('/calendar');
      }
    } catch (error: any) {
      alert(error.message);
    }
  };

  return (
    <div className="container vh-100 d-flex justify-content-center align-items-center login-page-container">
      <div
        className="card p-4 login-card"
        style={{ width: '100%', maxWidth: '400px' }}
      >
        <h2 className="text-center mb-4">Login</h2>
        <div className="mb-3">
          <input
            type="text"
            className="form-control"
            placeholder="Benutzername"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
          />
        </div>
        <div className="mb-3 input-group">
          <input
            type={showPassword ? 'text' : 'password'}
            className="form-control"
            placeholder="Passwort"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <button className="btn btn-outline-secondary" type="button" onClick={() => setShowPassword(!showPassword)}>
            <i className={showPassword ? 'bi bi-eye-slash' : 'bi bi-eye'}></i>
          </button>
        </div>
        <button className="btn btn-primary w-100" onClick={handleLogin}>
          Anmelden
        </button>
      </div>
    </div>
  );
};

export default LoginPage;
